import type { EditorAppearance } from '@atlaskit/editor-common/types';
import {
	akEditorFullWidthLayoutWidth,
	akEditorFullPageNarrowBreakout,
	akEditorGutterPadding,
	akEditorGutterPaddingDynamic,
	akEditorGutterPaddingReduced,
} from '@atlaskit/editor-shared-styles';
import type { AlignmentValue } from '@atlaskit/native-embeds-common';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';

export const calcMaxWidth = (
	containerWidth: number,
	editorAppearance?: EditorAppearance,
): number => {
	const fullPagePadding =
		editorAppearance === 'full-page' &&
		containerWidth <= akEditorFullPageNarrowBreakout &&
		editorExperiment('platform_editor_preview_panel_responsiveness', true, {
			exposure: true,
		})
			? akEditorGutterPaddingReduced
			: akEditorGutterPaddingDynamic();

	const fullWidthPadding =
		editorAppearance === 'full-page' ? fullPagePadding * 2 : akEditorGutterPadding * 2;
	return Math.min(containerWidth - fullWidthPadding, akEditorFullWidthLayoutWidth);
};

// ---------------------------------------------------------------------------
// Shared constants used by ResizableNativeEmbed coordinator + EmbedResizeOverlay
// ---------------------------------------------------------------------------

// TODO: CNS-24595 - use the constants file.
export const MIN_WIDTH = 200;
export const SNAP_GAP = 8;
export const CSS_VAR_NATIVE_EMBED_WIDTH = '--native-embed-width';

export const resizerNextTestId = 'nativeEmbed.resizerNext.testid';

/**
 * Maps AlignmentValue to RichMediaLayout for guideline snapping.
 * AlignmentValue uses 'left'/'right', but RichMediaLayout expects 'align-start'/'align-end'.
 */
export const mapAlignmentToLayout = (
	alignment: AlignmentValue,
): 'align-start' | 'align-end' | 'center' | 'wrap-left' | 'wrap-right' => {
	if (alignment === 'left') {
		return 'align-start';
	}
	if (alignment === 'right') {
		return 'align-end';
	}
	// 'center', 'wrap-left', 'wrap-right' pass through unchanged
	return alignment;
};
